import AjudaModuloCategoriaService from "@/services/AjudaModuloCategoriaService";

export const ajudaModuloCategoria = {
  namespaced: true,
  state: {
    ajudaModuloCategoria: {},
  },
  actions: {
    getAjudaModuloCategoria({ commit }, payload) {
      return AjudaModuloCategoriaService.GetAjudaModuloCategoria(payload).then(
        (ajudaModuloCategoria) => {
          return Promise.resolve(ajudaModuloCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAjudaModuloCategoria({ commit }, payload) {
      return AjudaModuloCategoriaService.PostAjudaModuloCategoria(payload).then(
        (ajudaModuloCategoria) => {
          return Promise.resolve(ajudaModuloCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAjudaModuloCategoria({ commit }, payload) {
      return AjudaModuloCategoriaService.PutAjudaModuloCategoria(payload).then(
        (ajudaModuloCategoria) => {
          return Promise.resolve(ajudaModuloCategoria);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAjudaModuloCategoria({ commit }, payload) {
      return AjudaModuloCategoriaService.DeleteAjudaModuloCategoria(
        payload
      ).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAjudaModuloCategoriaOData({ commit }, payload) {
      return AjudaModuloCategoriaService.GetAjudaModuloCategoriaOData(
        payload
      ).then(
        (ajudaModuloCategoria) => {
          return Promise.resolve(ajudaModuloCategoria);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default ajudaModuloCategoria;
